/**
 * Luật thuần của mục "Mã khôi phục" ở màn Tài khoản của tôi.
 *
 * Mã khôi phục là lối dự phòng của ứng dụng xác thực: chỉ có nghĩa khi người
 * dùng **đã** cài ứng dụng, nên chưa cài thì mục bị ẩn (không hiện mờ,
 * ADR-UI-0005) và câu mô tả của mục ứng dụng xác thực nói trước điều đó.
 */
import type { MaKhoiPhuc, XacThucCuaToi } from '../types.ts';

/** Loại credential của Keycloak cho bộ mã khôi phục (Account API `GET /credentials`). */
export const LOAI_MA_KHOI_PHUC = 'recovery-authn-codes';

/** Một nhóm credential của `GET /account/credentials` — chỉ phần cần đọc. */
export interface NhomCredential {
  type: string;
  userCredentialMetadatas?: {
    credential: { id: string; userLabel?: string; createdDate?: number };
  }[];
}

/**
 * Đọc trạng thái mã khôi phục từ danh sách nhóm credential. Không có nhóm
 * `recovery-authn-codes` là **không rõ**, không phải "chưa tạo": Keycloak chỉ
 * trả nhóm của loại credential realm đang bật.
 */
export function docMaKhoiPhuc(nhom: NhomCredential[]): MaKhoiPhuc {
  const cua = nhom.find((n) => n.type === LOAI_MA_KHOI_PHUC);
  if (!cua) return { trangThai: 'khongRo', taoLuc: null };
  const dau = cua.userCredentialMetadatas?.[0]?.credential;
  if (!dau) return { trangThai: 'chuaTao', taoLuc: null };
  return { trangThai: 'daTao', taoLuc: dau.createdDate ? new Date(dau.createdDate).toISOString() : null };
}

/** Hiện mục "Mã khôi phục" khi đã cài ít nhất một ứng dụng xác thực. */
export const hienMucMaKhoiPhuc = (xt: Pick<XacThucCuaToi, 'ungDungXacThuc'>): boolean =>
  xt.ungDungXacThuc.length > 0;

/**
 * Nút của mục: đã có bộ mã thì "Tạo lại" (bộ cũ hết hiệu lực khi tạo xong bộ
 * mới); chưa có hoặc không rõ thì "Tạo" — trang Keycloak tự lo cả hai trường hợp.
 */
export const nutMaKhoiPhuc = (mkp: MaKhoiPhuc): 'tao' | 'taoLai' =>
  mkp.trangThai === 'daTao' ? 'taoLai' : 'tao';
